export const reportTypes = {
  FINAL_POPULATION: 'A',
  POTENTIAL_POPULATION: 'PP',
};
